'use client';

import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import StatusBar from 'src/components/primitives/StatusBar/StatusBar';

const EmulationBar = () => {
	const viewingAuthority = useDriftStore((s) => s.authorityParam);
	const isEmulatingAccount = useDriftStore((s) => s.isEmulatingAccount);
	const shouldRender = isEmulatingAccount;

	if (!shouldRender) {
		return null;
	}

	const authority = viewingAuthority?.replace('authority=', '');

	return (
		<StatusBar variant="info">
			You are currently viewing {authority}&apos;s wallet. Actions will not
			work. Access app.drift.trade to connect your own wallet.
		</StatusBar>
	);
};

export default EmulationBar;
